(function () {
  'use strict';

  var labels = window.MM_HEADER_SEARCH || {};

  function root() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      var r = window.Shopify.routes.root;
      return r.slice(-1) === '/' ? r : r + '/';
    }
    return window.location.pathname.indexOf('/ar') === 0 ? '/ar/' : '/';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function localizedUrl(url) {
    if (!url) return '#';
    var r = root();
    if (r === '/') return url;
    var path = url;
    if (url.indexOf('http') === 0) {
      try { path = new URL(url).pathname; } catch (e) {}
    }
    path = path.replace(/^\/ar(?=\/)/, '');
    if (path.charAt(0) !== '/') path = '/' + path;
    return r.replace(/\/$/, '') + path;
  }

  function productText(product) {
    return [
      product.title,
      product.vendor,
      product.product_type,
      product.handle
    ].filter(Boolean).join(' ');
  }

  function scoreProduct(query, product) {
    var smart = window.MMSmartSearch;
    if (!smart || typeof smart.matchesFuzzySearch !== 'function') return 1;
    return smart.matchesFuzzySearch(query, productText(product)) ? 2 : 0;
  }

  function imageUrl(product) {
    var img = product.image || product.featured_image;
    if (img && img.url) img = img.url;
    if (typeof img === 'string' && img) return img;
    return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"%3E%3Crect fill="%23f3f4f6" width="56" height="56"/%3E%3C/svg%3E';
  }

  function formatPrice(product) {
    var raw = product.price;
    if (raw == null || raw === '') return '';
    var minor = 0;
    if (typeof raw === 'number') minor = raw;
    else {
      var n = parseFloat(String(raw).replace(/[^\d.]/g, '')) || 0;
      minor = n > 1000 ? Math.round(n) : Math.round(n * 100);
    }
    if (window.mmCurrencyConfig && typeof window.mmCurrencyConfig.formatWithTax === 'function') {
      return window.mmCurrencyConfig.formatWithTax(minor, 100);
    }
    if (window.mmTaxConfig && typeof window.mmTaxConfig.formatWithTax === 'function') {
      return window.mmTaxConfig.formatWithTax(minor);
    }
    return product.price || '';
  }

  function extractProducts(data) {
    return (data && data.resources && data.resources.results && data.resources.results.products) || [];
  }

  function render(target, products, query) {
    if (!target) return;
    if (!products.length) {
      target.innerHTML = '<div class="mm-predictive-no-results">' + esc(labels.noResults || 'No results found') + '</div>';
      target.hidden = false;
      return;
    }
    var html = '<div class="mm-predictive-header">' + esc(labels.products || 'Products') + '</div>';
    products.forEach(function (product) {
      var price = formatPrice(product);
      html += '<a href="' + esc(localizedUrl(product.url)) + '" class="mm-predictive-item">' +
        '<img src="' + esc(imageUrl(product)) + '" alt="" class="mm-predictive-item-image" width="100" height="100" loading="lazy">' +
        '<div class="mm-predictive-item-info">' +
        '<div class="mm-predictive-item-title">' + esc(product.title) + '</div>' +
        (price ? '<div class="mm-predictive-item-price">' + esc(price) + '</div>' : '') +
        '</div></a>';
    });
    html += '<a href="' + esc(localizedUrl('/')) + '?q=' + encodeURIComponent(query) + '#mmh-catalog" class="mm-predictive-view-all">' +
      esc(labels.viewAll || 'View all results') + '</a>';
    target.innerHTML = html;
    target.hidden = false;
  }

  function wire(input, target) {
    if (!input || !target) return;
    var timer = null;
    var controller = null;
    input.setAttribute('dir', document.documentElement.getAttribute('dir') || 'auto');
    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(timer);
      if (controller) controller.abort();
      if (query.length < 2) {
        target.innerHTML = '';
        target.hidden = true;
        return;
      }
      target.innerHTML = '<div class="mm-predictive-loading">' + esc(labels.searching || 'Searching') + '</div>';
      target.hidden = false;
      timer = setTimeout(function () {
        controller = new AbortController();
        var params = '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
        fetch(root() + 'search/suggest.json' + params, { signal: controller.signal })
          .then(function (r) {
            if (!r.ok) return fetch('/search/suggest.json' + params, { signal: controller.signal });
            return r;
          })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = extractProducts(data)
              .map(function (p) { return { product: p, score: scoreProduct(query, p) }; })
              .filter(function (row) { return row.score > 0; })
              .sort(function (a, b) { return b.score - a.score; })
              .map(function (row) { return row.product; });
            render(target, products, query);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            target.innerHTML = '<div class="mm-predictive-no-results">' + esc(labels.error || 'Search error. Please try again.') + '</div>';
            target.hidden = false;
          });
      }, 220);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) input.dispatchEvent(new Event('input'));
    });
  }

  function init() {
    wire(document.getElementById('mm-search-input'), document.getElementById('mm-predictive-results'));
    wire(document.getElementById('mm-mobile-search-input'), document.getElementById('mm-mobile-search-results'));
    document.addEventListener('click', function (e) {
      if (e.target.closest('.mm-search-wrapper') || e.target.closest('.mm-mobile-search-modal')) return;
      var desktop = document.getElementById('mm-predictive-results');
      if (desktop) desktop.hidden = true;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
